export default {
  app: {
    url: process.env.REACT_APP_SERVER_URL,
    version: `${process.env.REACT_APP_CUSTOMER_NAME || 'PushMetrics'} v2.9.36`, // vX.Y.Z must be the same as in package.json
    default_email_from: process.env.REACT_APP_DEFAULT_EMAIL_FROM,
    default_email_sender_name: process.env.REACT_APP_DEFAULT_EMAIL_SENDER_NAME,
    logo_url: process.env.REACT_APP_LOGO_URL,
    customer_name: process.env.REACT_APP_CUSTOMER_NAME || 'PushMetrics',
    ip_to_whitelist_info: process.env.IP_TO_WHITELIST_INFO || '18.156.113.81/32'
  },
  intercom: {
    appId: process.env.REACT_APP_INTERCOM_APP_ID,
  },
  segment: {
    enabled: process.env.REACT_APP_SEGMENT_ENABLED,
  },
  slack: {
    clientId: process.env.REACT_APP_SLACK_CLIENT_ID,
  },
  stripe: {
    pricingTableId: process.env.REACT_APP_STRIPE_PRICING_TABLE_ID,
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  },
  tinymce: {
    apiKey: process.env.REACT_APP_TINYMCE_API_KEY,
  },
  premise_features: {
    custom_links: process.env.CUSTOM_LINKS === 'true',
  },
};
